// extracted by mini-css-extract-plugin
export default {"chunksCard":"styles__chunksCard___MNWJq","highlight":"styles__highlight___LUR2r","disabled":"styles__disabled___VsBvY","titleBlock":"styles__titleBlock____S9tq"};